import React, { useContext, useEffect, useState } from 'react'
import { HideLoder, LogInSchoolID, LogInUserID, ShowLoder } from '../JS/Common';
import { ApiGetCall, ApiPostCall } from '../JS/Connector';
import AlertsComp from './AlertsComp';
import Popup from './Popup';
import { useSelector } from 'react-redux';
import useConfig from '../Hooks/useConfig';

function TicketStatuspopup(props) {
    const { organization, adminCallNode } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const [TicketStatus, setTicketStatus] = useState([]);
    const [NewAlerts, setNewAlerts] = useState("");
    const [TicketStatusData, setTicketStatusData] = useState({
        TicketAccess: '',
        TicketAccessForClose: 0,
        Errormsg: '',
        Errormsg1: '',
        ticketstatusnotes: '',
        TicketStatusCode: ''
    })
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (props.GridFlag == 1) {
            var flag = 1
        } else if (props.GridFlag == 2 || props.GridFlag == 3) {
            var flag = 2
        } else if (props.GridFlag == 5) {
            var flag = 3
        } else if (props.GridFlag == 4) {
            var flag = [2, 7, 8, 18]?.includes(props.TicketStatusId) ? 2 : 4;
        } else if (props.GridFlag == 6) {
            var flag = 5
        }
        setLoading(true);
        ApiGetCall(`/tickets/statuses?flag=${flag}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setTicketStatus(responseRs);
                setLoading(false);
            }
        });
        setTicketStatusData({ ...TicketStatusData, TicketAccess: props.TicketStatusId })
    }, [])
    async function StatusCall() {
        setTicketStatusData({ ...TicketStatusData, Errormsg: 'Select atleast one option' })
        if (TicketStatusData.TicketAccessForClose == 0 && [2, 7, 8, 18].includes(TicketStatusData.TicketStatusCode) && props.Lonerflag == 'yes') {
            setTicketStatusData({ ...TicketStatusData, Errormsg1: 'Select atleast one option' })
            return
        }
        if (TicketStatusData.TicketAccess != '') {
            var vArray = []
            var vJson = {};
            vJson['TicketID'] = props.TicketId;
            vArray.push(vJson);
            var FlagforStatusForLoner = 0
            if (props.Lonerflag == 'yes') {
                var FlagforStatusForLoner = 1
            }
            var raw = JSON.stringify({
                userId: LogInUserID,
                issueIds: props.SelectAllFlag == 0 ? vArray : [],
                statusId: TicketStatusData.TicketAccess,
                flag: FlagforStatusForLoner,
                closeStatus: TicketStatusData.TicketAccessForClose,
                schoolId: LogInSchoolID,
                tabFlag: props.GridFlag,
                selectAllFlag: props.SelectAllFlag,
                searchString: props.GridFlag == 1 ? props?.searchString?.SearchForOpen :
                    props.GridFlag == 2 ? props?.searchString?.SearchForClose :
                        props.GridFlag == 3 ? props?.searchString?.SearchForPending :
                            props.GridFlag == 4 ? props?.searchString?.SearchForAll
                                : ''
            });
            setLoading(true)
            await ApiPostCall("/tickets/change-status", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    if (result == "success") {
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={"Status Updated Successfully"} />);
                        setTimeout(function () {
                            setNewAlerts(<AlertsComp show={false} />)
                            props.ClosePopup();
                            props.clearSearch();
                            props.setSelectedIds([]);
                            props.setSelectAllFlag(0);
                            if (props.GridFlag == 1) {
                                props.GetGridData(1, null, null, null, false)
                            } else if (props.GridFlag == 2) {
                                props.GetGridData(2, null, null, null, false)
                            } else if (props.GridFlag == 3) {
                                props.GetGridData(3, null, null, null, false)
                            } else if (props.GridFlag == 4) {
                                props.GetGridData(4, null, null, null, false)
                            } else {
                                props.GetGridData(5, null, null, null, false)
                            }
                        }, 1500);
                    } else {
                        setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                        setTimeout(() => {
                            setNewAlerts(<AlertsComp show={false} />)
                        }, 2000);
                    }
                }
            });
        }
    }
    async function StatusCallForAdmin() {
        setTicketStatusData({ ...TicketStatusData, Errormsg: 'Select atleast one option' })
        if (TicketStatusData.TicketAccess != '') {
            var vArray = [];
            var vjson = {};
            vjson['ID'] = props.TicketId;
            vjson['StudentID'] = props.StudentidForSatuschange == undefined ? null : props.StudentidForSatuschange;
            vArray.push(vjson);
            var raw = JSON.stringify({
                userId: LogInUserID,
                ticketIdArray: props.SelectAllFlag == 0 ? vArray : [],
                statusId: TicketStatusData.TicketAccess,
                note: TicketStatusData.ticketstatusnotes,
                whoWorkedOnId: StateData?.csvUserID,
                schoolId: props.schoolId,
                selectAllFlag: props.SelectAllFlag,
                tabFlag: props.flag == 1 || props.flag == 2 || props.flag == 3 ? 1 : 2,
                searchString: props.flag == 1 ? props?.TicketsTabs?.SearchForAtVendor :
                    props.flag == 2 ? props?.TicketsTabs?.searchForSentOutForRepair :
                        props.flag == 3 ? props?.TicketsTabs?.SearchForOpen :
                            props.flag == 4 ? props?.TicketsTabs?.SearchForRepairFinished :
                                props.flag == 5 ? props?.TicketsTabs?.SearchForRepairBilled :
                                    props.flag == 6 ? props?.TicketsTabs?.SearchForClosed
                                        : ''
            });
            setLoading(true)
            await ApiPostCall(`${adminCallNode}/tickets/change-status`, raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    if (result == "success") {
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={"Status Updated Successfully"} />);
                        setTimeout(function () {
                            setNewAlerts(<AlertsComp show={false} />)
                            props.ClosePopup();
                            props.setSelectAllFlag(0);

                            props.setSelectedIdsAtVendor1([]);
                            props.setSelectedIdsSentOut1([]);
                            props.setSelectedIdsRepairFinished1([]);
                            props.setSelectedIdsRepairBilled1([]);
                            props.setSelectedIdsOpen1([]);
                            props.setSelectedIdsClosed1([]);

                            props.setSelectedIdsAtVendor([]);
                            props.setSelectedIdsSentOut([]);
                            props.setSelectedIdsRepairFinished([]);
                            props.setSelectedIdsRepairBilled([]);
                            props.setSelectedIdsOpen([]);
                            props.setSelectedIdsClosed([]);

                            var batchid = props.selectedbatchid
                            if (batchid == 0) {
                                batchid = null
                            }
                            if (props.tabflagforadmin == 1) {
                                props.GetGridData(null, 1, batchid, null, false)
                            } else if (props.tabflagforadmin == 2) {
                                props.GetGridData(null, 2, batchid, null, false)
                            } else if (props.tabflagforadmin == 3) {
                                props.GetGridData(null, 3, batchid, null, false)
                            } else if (props.tabflagforadmin == 4) {
                                props.GetGridData(null, 4, batchid, null, false)
                            } else if (props.tabflagforadmin == 5) {
                                props.GetGridData(null, 5, batchid, null, false)
                            } else {
                                props.GetGridData(null, 6, batchid, null, false)
                            }
                        }, 1500);
                    } else {
                        setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                        setTimeout(() => {
                            setNewAlerts(<AlertsComp show={false} />)
                        }, 2000);
                    }
                }
            });
        }
    }
    const modalbody = (
        <>
            <div>
                {TicketStatus.map((item, i) => {
                    var returData;
                    returData = (
                        <div className="col-md-12 py-2 pe-0" key={i}>
                            {props.TicketStatusId == item.id ?
                                <input className="form-check-input me-2 TicketStatus" defaultChecked statusid={item.id} type="radio" name="ticketstatus"
                                    onChange={(e) => setTicketStatusData({ ...TicketStatusData, TicketAccess: item.id, Errormsg1: '', TicketStatusCode: item.ticket_status_code })} />
                                :
                                <input className="form-check-input me-2 TicketStatus" statusid={item.id} type="radio" name="ticketstatus"
                                    onChange={(e) => setTicketStatusData({ ...TicketStatusData, TicketAccess: item.id, Errormsg1: '', TicketStatusCode: item.ticket_status_code })} />
                            }

                            {item.status}
                        </div>
                    );
                    return returData;
                })}
                {([2, 7, 8, 18].includes(TicketStatusData.TicketStatusCode) && props.Lonerflag === 'yes') ?
                    <div className="col-12" id="CLoseTicketLoanerDivId">
                        <hr />
                        <h4>Close Ticket</h4>
                        <hr />
                        <div className="col-12 pb-3">
                            <input className="form-check-input me-2 CommonCloseTicketClass" type="radio" name="CloseStatus" id="FreeDevice"
                                onChange={(e) => setTicketStatusData({ ...TicketStatusData, TicketAccessForClose: 2 })} />Give Original Device Back To User?
                        </div>
                        <div className="col-12">
                            <input className="form-check-input me-2 CommonCloseTicketClass" type="radio" name="CloseStatus" id="ParmanentDevice"
                                onChange={(e) => setTicketStatusData({ ...TicketStatusData, TicketAccessForClose: 1 })} /> Keep loaner device as a permanent device for {organization?.toLowerCase()}?
                        </div>
                    </div>
                    : <></>}

                {props.GridFlag == 5 || props.GridFlag == 6 && (
                    <div className="col-12">
                        <textarea rows={3} className="form-control" value={TicketStatusData.ticketstatusnotes} onChange={(e) => setTicketStatusData({ ...TicketStatusData, ticketstatusnotes: e.target.value })}></textarea>
                        <span>Notes</span>
                    </div>
                )}
            </div>

            {TicketStatusData.TicketAccess == '' ?
                <div className="redText px-5" id='statusMsg'>{TicketStatusData.Errormsg}</div>
                : <></>
            }
            {TicketStatusData.TicketAccessForClose == 0 ?
                <div className="redText px-5" id='statusMsg'>{TicketStatusData.Errormsg1}</div>
                : <></>
            }
        </>
    )
    return (
        <>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"md"} title={"Ticket Status"}
                closePopup={props.ClosePopup}
                modalBody={modalbody} handleSave={(e) => props.GridFlag == 5 || props.GridFlag == 6 ? StatusCallForAdmin(e) : StatusCall(e)} visibleSaveBtn={true} btnText={"Change Status"} />
        </>
    )
}

export default TicketStatuspopup
